import { clsx } from "clsx";
import type { IssueStatus } from "@/features/dev_issues/types";
import { ISSUE_STATUS_LABELS } from "@/features/dev_issues/types";

const statusStyles: Record<IssueStatus, string> = {
  open: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300",
  in_progress: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300",
  resolved: "bg-green-100 text-green-600 dark:bg-green-900/40 dark:text-green-300",
  wont_fix: "bg-gray-100 text-gray-500 dark:bg-gray-700/50 dark:text-gray-400",
};

interface Props {
  status: IssueStatus;
  className?: string;
}

export function IssueStatusBadge({ status, className }: Props) {
  return (
    <span
      className={clsx(
        "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium",
        statusStyles[status],
        className
      )}
    >
      {ISSUE_STATUS_LABELS[status]}
    </span>
  );
}
